import { useCallback, useState } from "react";

export function getNextTableSort(current, key) {
  return {
    key,
    direction:
      current?.key === key && current?.direction === "asc" ? "desc" : "asc",
  };
}

export function useTableSort(initialKey = null, initialDirection = "asc") {
  const [sort, setSort] = useState({
    key: initialKey,
    direction: initialDirection,
  });

  const toggleSort = useCallback((key) => {
    setSort((current) => getNextTableSort(current, key));
  }, []);

  return { sort, setSort, toggleSort };
}
